import { connect } from 'react-redux';
import ProductOverview from './full';
// import ProductOverview from '@gcc/pip-components/dist/templates/ProductOverview';

const mapStateToProps = (state, ownProps) => {
  const {
    Attributes,
  } = state.products.currentProducts[ownProps.productId] || { Attributes: {} };

  return {
    productDescription: Attributes['Product Description'] || '',
    shortDescription: Attributes['Short Description'] || '',
    quickLinks: Attributes['Quick Links'] || '',
  };
};

export default connect(mapStateToProps)(ProductOverview);